import {
    request,
    requestPublic
} from './request.js'

// 获取报名信息分页 
export function getRegistrationInfos(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/PaginationRegistrationInfos',
        method: 'get',
        params: {
            PageNumber: obj.pageIndex,
            PageSize: obj.pageSize,
            Name: obj.name,
            TelNumber: obj.telNumber,
            School: obj.school,
            Major: obj.major,
            StartTime: obj.startTime,
            EndTime: obj.endTime,
            Source: obj.source,
            Identity: obj.identity,
            Status: obj.status,
            EnrollmentType: obj.enrollmentType,
        }
    })
}

// 删除指定报名信息 
export function removeInfo(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/RemoveRegistrationInfo',
        method: 'post',
        params: {
            id: id
        }
    })
}

// 添加报名信息 
export function addInfo(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/AddRegistrationInfo',
        method: 'post',
        data: data
    })
}

// 审批报名信息 
export function examineRegistration(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/ExamineRegistration',
        method: 'post',
        data: data
    })
}

// 导出报名信息 
export function exportRegistrationInfo(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/ExportRegistrationInfo',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}


// 获取注册信息来源
export function getRegistrationSourceTypes() {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/GetRegistrationSourceTypes',
        method: 'get'
    })
}

// 获取身份信息类型
export function getIdentityTypesAsync() {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/GetIdentityTypesAsync',
        method: 'get'
    })
}

// 获取报名信息类型
export function getEnrollmentTypes() {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/GetEnrollmentTypes',
        method: 'get'
    })
}

// 获取报名状态的所有值
export function getStatusValues() {
    return request({
        url: '/api2/ZsbSiteAdmin/Registration/GetStatusValues',
        method: 'get'
    })
}